import React from 'react'

const PrivacyPage: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Kebijakan Privasi</h1>
        
        <div className="prose prose-lg max-w-none">
          <p className="text-gray-600 mb-6">
            <strong>Terakhir diperbarui:</strong> {new Date().toLocaleDateString('id-ID')}
          </p>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Informasi yang Kami Kumpulkan</h2>
            <div className="bg-gray-50 p-6 rounded-lg mb-4">
              <h3 className="text-lg font-medium mb-3">Informasi Pribadi</h3>
              <ul className="list-disc pl-6 space-y-2">
                <li>Nama lengkap dan alamat email</li>
                <li>Informasi kontak (nomor telepon, alamat)</li>
                <li>Informasi pembayaran (diproses melalui Midtrans)</li>
                <li>Riwayat pembelian dan preferensi produk</li>
              </ul>
            </div>
            
            <div className="bg-blue-50 p-6 rounded-lg mb-4">
              <h3 className="text-lg font-medium mb-3">Informasi Teknis</h3>
              <ul className="list-disc pl-6 space-y-2">
                <li>Alamat IP dan lokasi geografis</li>
                <li>Informasi perangkat dan browser</li>
                <li>Log aktivitas dan audit trail</li>
                <li>Cookie dan data sesi</li>
              </ul>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Bagaimana Kami Menggunakan Informasi</h2>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-green-50 p-6 rounded-lg">
                <h3 className="text-lg font-medium mb-3">Tujuan Utama</h3>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Memproses pesanan dan pembayaran</li>
                  <li>Mengirim produk digital</li>
                  <li>Memberikan dukungan pelanggan</li>
                  <li>Mengirim notifikasi penting</li>
                </ul>
              </div>
              
              <div className="bg-purple-50 p-6 rounded-lg">
                <h3 className="text-lg font-medium mb-3">Keamanan & Analitik</h3>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Mencegah penipuan dan penyalahgunaan</li>
                  <li>Audit keamanan dan compliance</li>
                  <li>Analisis performa website</li>
                  <li>Peningkatan layanan</li>
                </ul>
              </div>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Keamanan Data</h2>
            <div className="bg-red-50 border-l-4 border-red-400 p-6 rounded-lg">
              <h3 className="text-lg font-medium mb-3">🔐 Langkah-langkah Keamanan</h3>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Enkripsi End-to-End:</strong> Semua data sensitif dienkripsi</li>
                <li><strong>Two-Factor Authentication:</strong> Perlindungan akun berlapis</li>
                <li><strong>Audit Logging:</strong> Semua aktivitas tercatat dan dipantau</li>
                <li><strong>Rate Limiting:</strong> Perlindungan dari serangan brute force</li>
                <li><strong>Security Headers:</strong> Perlindungan dari XSS dan clickjacking</li>
                <li><strong>Cloudflare Security:</strong> DDoS protection dan WAF</li>
              </ul>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Berbagi Informasi</h2>
            <div className="bg-yellow-50 p-6 rounded-lg">
              <p className="mb-4">Kami <strong>TIDAK</strong> menjual atau menyewakan data pribadi Anda kepada pihak ketiga.</p>
              <h3 className="text-lg font-medium mb-3">Pengecualian Terbatas:</h3>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Payment Processor:</strong> Midtrans untuk memproses pembayaran</li>
                <li><strong>Cloud Infrastructure:</strong> Cloudflare untuk hosting dan keamanan</li>
                <li><strong>Legal Compliance:</strong> Jika diwajibkan oleh hukum</li>
                <li><strong>Business Transfer:</strong> Dalam kasus merger atau akuisisi</li>
              </ul>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Hak-hak Anda (GDPR)</h2>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-indigo-50 p-6 rounded-lg">
                <h3 className="text-lg font-medium mb-3">Hak Akses & Kontrol</h3>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Mengakses data pribadi Anda</li>
                  <li>Memperbaiki data yang tidak akurat</li>
                  <li>Menghapus data pribadi</li>
                  <li>Membatasi pemrosesan data</li>
                </ul>
              </div>
              
              <div className="bg-teal-50 p-6 rounded-lg">
                <h3 className="text-lg font-medium mb-3">Hak Portabilitas</h3>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Mengunduh data Anda</li>
                  <li>Transfer ke layanan lain</li>
                  <li>Menolak pemrosesan otomatis</li>
                  <li>Mengajukan keluhan</li>
                </ul>
              </div>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Cookie dan Tracking</h2>
            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="text-lg font-medium mb-3">Jenis Cookie yang Kami Gunakan:</h3>
              <div className="space-y-4">
                <div>
                  <h4 className="font-medium">🍪 Essential Cookies</h4>
                  <p className="text-sm text-gray-600">Diperlukan untuk fungsi dasar website (login, keranjang belanja)</p>
                </div>
                <div>
                  <h4 className="font-medium">📊 Analytics Cookies</h4>
                  <p className="text-sm text-gray-600">Membantu kami memahami penggunaan website</p>
                </div>
                <div>
                  <h4 className="font-medium">🔒 Security Cookies</h4>
                  <p className="text-sm text-gray-600">Melindungi dari serangan dan penipuan</p>
                </div>
              </div>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Retensi Data</h2>
            <div className="bg-orange-50 p-6 rounded-lg">
              <h3 className="text-lg font-medium mb-3">Periode Penyimpanan:</h3>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Data Akun:</strong> Selama akun aktif + 2 tahun</li>
                <li><strong>Transaksi:</strong> 7 tahun (sesuai regulasi keuangan)</li>
                <li><strong>Audit Logs:</strong> 1 tahun</li>
                <li><strong>Session Data:</strong> 30 hari</li>
                <li><strong>Marketing Data:</strong> Hingga Anda opt-out</li>
              </ul>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Transfer Data Internasional</h2>
            <div className="bg-blue-50 p-6 rounded-lg">
              <p className="mb-4">Data Anda dapat diproses di server yang berlokasi di:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Cloudflare Global Network:</strong> Dengan perlindungan GDPR</li>
                <li><strong>Indonesia:</strong> Server lokal untuk compliance</li>
                <li><strong>Singapura:</strong> Backup dan disaster recovery</li>
              </ul>
              <p className="mt-4 text-sm text-gray-600">
                Semua transfer data menggunakan safeguards yang sesuai dengan GDPR.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Kontak & Keluhan</h2>
            <div className="bg-gray-100 p-6 rounded-lg">
              <h3 className="text-lg font-medium mb-3">Data Protection Officer</h3>
              <div className="space-y-2">
                <p><strong>Email:</strong> privacy@hilaltechnologic.info</p>
                <p><strong>Alamat:</strong> Hilal Technologic, Indonesia</p>
                <p><strong>Response Time:</strong> Maksimal 30 hari</p>
              </div>
              
              <div className="mt-6 p-4 bg-white rounded border">
                <h4 className="font-medium mb-2">Untuk Mengajukan Permintaan GDPR:</h4>
                <ol className="list-decimal pl-6 space-y-1 text-sm">
                  <li>Kirim email ke privacy@hilaltechnologic.info</li>
                  <li>Sertakan bukti identitas</li>
                  <li>Jelaskan permintaan Anda dengan detail</li>
                  <li>Kami akan merespons dalam 30 hari</li>
                </ol>
              </div>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">10. Perubahan Kebijakan</h2>
            <div className="bg-green-50 p-6 rounded-lg">
              <p className="mb-4">
                Kami dapat memperbarui kebijakan privasi ini dari waktu ke waktu. 
                Perubahan material akan diberitahukan melalui:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Email notifikasi ke semua pengguna</li>
                <li>Banner pemberitahuan di website</li>
                <li>Update tanggal "Terakhir diperbarui"</li>
              </ul>
            </div>
          </section>

          <div className="mt-12 p-6 bg-gradient-to-r from-blue-50 to-purple-50 rounded-lg border">
            <h3 className="text-lg font-medium mb-3">🛡️ Komitmen Keamanan Kami</h3>
            <p className="text-gray-700">
              Hilal Technologic berkomitmen untuk melindungi privasi dan keamanan data Anda. 
              Kami menggunakan teknologi terdepan dan mengikuti best practices industri untuk 
              memastikan data Anda aman dan terlindungi.
            </p>
            <div className="mt-4 flex flex-wrap gap-2">
              <span className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm">GDPR Compliant</span>
              <span className="px-3 py-1 bg-green-100 text-green-800 rounded-full text-sm">ISO 27001</span>
              <span className="px-3 py-1 bg-purple-100 text-purple-800 rounded-full text-sm">SOC 2 Type II</span>
              <span className="px-3 py-1 bg-red-100 text-red-800 rounded-full text-sm">PCI DSS</span>
            </div>
          </div>
      </div>
    </div>
  )
}

export default PrivacyPage
